/**
 * Get a deserializer by type, node names, class names and styles.
 */
const getNodeDeserializer = ({
  type,
  node,
  attributes,
  rules,
  withoutChildren
}) => {
  const deserializers = [];
  rules.forEach(({
    nodeNames: ruleNodeNames = '*',
    style,
    attribute
  }) => {
    const nodeNames = castArray(ruleNodeNames);
    nodeNames.forEach(nodeName => {
      deserializers.push({
        type,
        withoutChildren,
        deserialize: el => {
          if (nodeNames.length && !nodeNames.includes(el.nodeName) && nodeName !== '*') {
            return;
          }
          if (style) {
            if (typeof style === 'function') {
              if (!style(el.style)) {
                return;
              }
            } else {
              for (const [key, value] of Object.entries(style)) {
                const values = castArray(value);
                const property = el.style[key];
                if (typeof property !== 'string' || !values.includes(property)) {
                  return;
                }
              }
            }
          }
          if (attribute) {
            if (typeof attribute === 'string') {
              if (!el.getAttributeNames().includes(attribute)) {
                return;
              }
            } else {
              for (const [key, value] of Object.entries(attribute)) {
                const attr = el.getAttribute(key);
                if (typeof value === 'function') {
                  if (!value(attr)) {
                    return;
                  }
                } else {
                  const values = castArray(value);
                  if (!attr || !values.includes(attr)) {
                    return;
                  }
                }
              }
            }
          }
          const htmlAttributes = {};
          if (attributes) {
            const attributeNames = el.getAttributeNames();
            for (const attr of attributes) {
              if (attributeNames.includes(attr)) {
                htmlAttributes[attr] = el.getAttribute(attr);
              }
            }
          }
          const slateNode = node(el);
          if (slateNode && Object.keys(htmlAttributes).length) {
            slateNode.attributes = htmlAttributes;
          }
          return slateNode;
        }
      });
    });
  });
  return deserializers;
};
function castArray(value) {
  if (!value) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
}

export { getNodeDeserializer };
